import './style.scss'

import type { PropsWithChildren } from 'react'

import { useDocumentTitle } from 'shared/hooks'

export function NotFoundContainer({ children }: PropsWithChildren) {
	useDocumentTitle('404')

	return children
}
